// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__34RRb","fileBtn":"File_fileBtn__1O45L","closeBtn":"File_closeBtn__Tcid_","fileSelected":"File_fileSelected__2kTX8","disabled":"File_disabled__LWpGl"};